/**
 * Provider component for DataGridConfigContext.
 *
 * Mount once near the app root. Merges the supplied config over GENERIC_DEFAULTS
 * so partial configs work — only the slots you supply are overridden. The
 * formatters sub-object is merged shallowly so individual formatters can be
 * overridden without replacing the entire formatters map.
 *
 * Contains:
 * - DataGridConfigProvider — wraps a subtree with the merged DataGridConfig
 */

import React, { useMemo } from 'react';

import DataGridConfigContext, { GENERIC_DEFAULTS } from './DataGridConfigContext';

/**
 * @param {object} props
 * @param {Partial<typeof GENERIC_DEFAULTS>} props.config  ODL (or custom) config
 *   merged over GENERIC_DEFAULTS. Omitted slots fall back to generic behavior.
 * @param {React.ReactNode} props.children
 */
export default function DataGridConfigProvider({ config, children }) {
  const merged = useMemo(
    () => ({
      ...GENERIC_DEFAULTS,
      ...config,
      formatters: {
        ...GENERIC_DEFAULTS.formatters,
        ...(config?.formatters ?? {}),
      },
    }),
    [config],
  );

  return <DataGridConfigContext.Provider value={merged}>{children}</DataGridConfigContext.Provider>;
}
